import React from "react";
import MapComponent from "../components/map";

export default function Map(){
  return (
    <div>
      <MapComponent></MapComponent>
    </div>
  );
};